import React from 'react'
import './Promo.css'

const Promo = () => <div className="contacts_promo" />

export default Promo
